import services from '@/services/ascentiaServiceIndex'
import { POWER_BI_CONSTS as PBI } from '../consts'

const state = {
  airlineWorkspaces: [],
  powerBIDataset: [],
  airlineReports: [],
  isValidDashboardName: true,
  dashboardEmbedToken: null,
  isReportDuplicated: false,
  selectedDashboard: {
    pbiDatasets: {},
  },
  preservedDashboard: {},
}

const getters = {
  mappedAirlineWorkspaces: state => {
    if (state.airlineWorkspaces.length) {
      return state.airlineWorkspaces.map(item => {
        return {
          ...item,
          text: item.friendlyName,
          value: item.id,
        }
      })
    } else {
      return []
    }
  },
  mappedPowerBIDatasets: state => {
    if (state.powerBIDataset.length) {
      return state.powerBIDataset.map(item => {
        return {
          ...item,
          text: item.name,
          value: item.id,
        }
      })
    } else {
      return []
    }
  },
}

const mutations = {
  [PBI.UPDATE_AIRLINE_WORKSPACES]: (state, data) =>
    (state.airlineWorkspaces = data),
  [PBI.UPDATE_POWERBI_DATASET]: (state, data) => (state.powerBIDataset = data),
  [PBI.UPDATE_VALID_DASHBOARD_NAME]: (state, data) =>
    (state.isValidDashboardName = data),
  [PBI.UPDATE_AIRLINE_REPORTS]: (state, data) => (state.airlineReports = data),
  [PBI.UPDATE_DASHBOARD_EMBED_TOKEN]: (state, data) =>
    (state.dashboardEmbedToken = data),
  [PBI.UPDATE_AIRLINE_REPORT]: (state, data) =>
    state.airlineReports.splice(data.index, 1, data.updatedAirlineReport),
  [PBI.UPDATE_DUPLICATE_STATUS]: (state, data) =>
    (state.isReportDuplicated = data),
  [PBI.UPDATE_CREATED_OR_CLONED_RECORD]: (state, data) =>
    (state.airlineReports = [...state.airlineReports, data]),
  [PBI.UPDATE_SELECTED_POWERBI_DASHBOARD]: (state, data) =>
    (state.selectedDashboard = { ...state.selectedDashboard, ...data }),
  [PBI.REMOVE_SELECTED_POWERBI_DASHBOARD]: state =>
    (state.selectedDashboard = { pbiDatasets: {} }),
  [PBI.UPDATE_PRESERVED_POWERBI_DASHBOARD]: (state, data) => {
    state.preservedDashboard = JSON.parse(
      JSON.stringify({
        ...data,
      }),
    )
  },
}

const actions = {
  async [PBI.SET_SELECTED_POWERBI_DASHBOARD](
    { commit },
    selectedDashboardInfo,
  ) {
    try {
      commit(PBI.UPDATE_SELECTED_POWERBI_DASHBOARD, selectedDashboardInfo)
      commit(PBI.UPDATE_PRESERVED_POWERBI_DASHBOARD, selectedDashboardInfo)
    } catch (error) {
      console.log(`${[PBI.SET_SELECTED_POWERBI_DASHBOARD]}: error ${error}`)
    }
  },
  async [PBI.GET_AIRLINE_WORKSPACES]({ commit }) {
    try {
      const response = await services.powerBi.getData('workspaces', [], true)
      const data = response.data
      commit(PBI.UPDATE_AIRLINE_WORKSPACES, data)
    } catch (error) {
      console.log(`${[PBI.GET_AIRLINE_WORKSPACES]}: error ${error}`)
    }
  },
  async [PBI.GET_AIRLINE_REPORTS]({ commit, state }) {
    try {
      const response = await services.powerBi.getData('reports', [], true)
      const data = response.data
      const deleteReports = state.airlineReports.filter(f => f.isDeleted)
      deleteReports.forEach(item => {
        let val = data.findIndex(f => f.pbiReportId === item.pbiReportId)
        if (val > -1) {
          data[val].isDeleted = true
        }
      })
      commit(PBI.UPDATE_AIRLINE_REPORTS, data)
    } catch (error) {
      console.log(`${[PBI.GET_AIRLINE_REPORTS]}: error ${error}`)
    }
  },
  async [PBI.GET_POWERBI_DATASET]({ commit }) {
    try {
      const response = await services.powerBi.getData('datasets', [], true)
      const data = response.data
      let datasets = []
      data.forEach(element => {
        let pbiDatasetId = element.pbiDatasets[0].id
        let pbiWorkspaceId = element.pbiDatasets[0].pbiWorkspaceId
        datasets.push({
          ...element,
          pbiDatasetId: pbiDatasetId,
          pbiWorkspaceId: pbiWorkspaceId,
        })
      })
      commit(PBI.UPDATE_POWERBI_DATASET, datasets)
    } catch (error) {
      console.log(`${[PBI.GET_POWERBI_DATASET]}: error ${error}`)
    }
  },
  async [PBI.VALIDATE_POWERBI_DASHBOARD_NAME]({ commit }, params) {
    try {
      const request = {
        dashboardName: params.dashboardName,
        workspaceId: params.workspaceId,
        isCloneReport: params.isCloneReport,
        reportId: params.reportId,
      }
      const validateResponse = await services.powerBi.getData(
        'validateReportName',
        request,
        true,
      )
      commit(
        PBI.UPDATE_VALID_DASHBOARD_NAME,
        !validateResponse.data.isDuplicateName,
      )
    } catch (error) {
      console.log(`${[PBI.VALIDATE_POWERBI_DASHBOARD_NAME]}: error ${error}`)
    }
  },
  async [PBI.CREATE_CLONE_POWERBI_DASHBOARD]({ commit }, dashboardParams) {
    try {
      const request = {
        dashboardName: dashboardParams.dashboardName,
        workspaceId: dashboardParams.isCloneReport
          ? dashboardParams.workspaceId
          : dashboardParams.pbiAirline.value,
        isCloneReport: dashboardParams.isCloneReport || false,
      }
      const validateResponse = await services.powerBi.getData(
        'validateReportName',
        request,
        true,
      )
      commit(
        PBI.UPDATE_VALID_DASHBOARD_NAME,
        !validateResponse.data.isDuplicateName,
      )
      commit(PBI.UPDATE_DUPLICATE_STATUS, false)
      if (!validateResponse.data.isDuplicateName) {
        const createReportRequest = {
          dashboardName: dashboardParams.isCloneReport
            ? validateResponse.data.dashboardName
            : dashboardParams.dashboardName,
          profileGuid: dashboardParams.isCloneReport
            ? dashboardParams.profileGuid
            : dashboardParams.pbiAirline.pbiProfileId,
          workspaceGuid: dashboardParams.isCloneReport
            ? dashboardParams.workspaceGuid
            : dashboardParams.pbiAirline.pbiWorkspaceId,
          reportGuid: dashboardParams.isCloneReport
            ? dashboardParams.reportGuid
            : dashboardParams.pbiDataset.pbiReportId,
        }
        const response = await services.powerBi.saveData(
          'createReport',
          createReportRequest,
        )
        if (response.status === 201) {
          commit(PBI.UPDATE_CREATED_OR_CLONED_RECORD, response.data)
        }
        if (response.status === 201 && dashboardParams.isCloneReport) {
          commit(PBI.UPDATE_DUPLICATE_STATUS, true)
        } else {
          commit(PBI.UPDATE_DUPLICATE_STATUS, false)
        }
        return response.data
      }
    } catch (error) {
      console.log(`${[PBI.CREATE_CLONE_POWERBI_DASHBOARD]}: error ${error}`)
    }
  },
  async [PBI.GET_DASHBOARD_EMBED_TOKEN]({ commit }, reportId) {
    try {
      const response = await services.powerBi.getData(
        'embedToken',
        reportId,
        true,
      )
      const data = response.data
      commit(PBI.UPDATE_DASHBOARD_EMBED_TOKEN, data)
    } catch (error) {
      console.log(`${[PBI.GET_DASHBOARD_EMBED_TOKEN]}: error ${error}`)
    }
  },
  async [PBI.UPDATE_SHARING_PERMISSIONS]({ commit }, pbiReportId) {
    try {
      const updateRequest = {
        reportGuidString: pbiReportId,
      }
      const response = await services.powerBi.saveData(
        'updateReportPermissions',
        updateRequest,
      )
      if (response.status >= 200 && response.status < 300) {
        const currentStateReportIndex = state.airlineReports.findIndex(
          ar => ar.pbiReportId === pbiReportId,
        )

        var currentStateReport = state.airlineReports[currentStateReportIndex]
        currentStateReport = response.data
        const data = {
          index: currentStateReportIndex,
          updatedAirlineReport: currentStateReport,
        }
        commit(PBI.UPDATE_AIRLINE_REPORT, data)

        if (state.selectedDashboard) {
          commit(PBI.UPDATE_SELECTED_POWERBI_DASHBOARD, {
            lastEdited: currentStateReport.lastEdited,
            isShared: currentStateReport.isShared,
          })
          commit(PBI.UPDATE_PRESERVED_POWERBI_DASHBOARD, currentStateReport)
        }
      }
    } catch (error) {
      console.log(`${[PBI.UPDATE_SHARING_PERMISSIONS]}: error ${error}`)
    }
  },
  async [PBI.UPDATE_POWERBI_REPORT]({ commit }, dashboardParams) {
    try {
      const updateReportRequest = {
        dashboardName: dashboardParams.name,
        reportGuid: dashboardParams.pbiReportId,
      }

      const response = await services.powerBi.saveData(
        'updateReport',
        updateReportRequest,
      )
      if (response.status >= 200 && response.status < 300) {
        const currentStateReportIndex = state.airlineReports.findIndex(
          ar => ar.pbiReportId === dashboardParams.pbiReportId,
        )

        var currentStateReport = state.airlineReports[currentStateReportIndex]
        currentStateReport = response.data
        const data = {
          index: currentStateReportIndex,
          updatedAirlineReport: currentStateReport,
        }
        commit(PBI.UPDATE_AIRLINE_REPORT, data)

        if (state.selectedDashboard) {
          commit(PBI.UPDATE_SELECTED_POWERBI_DASHBOARD, {
            lastEdited: currentStateReport.lastEdited,
          })
          commit(PBI.UPDATE_PRESERVED_POWERBI_DASHBOARD, currentStateReport)
        }
      }
    } catch (error) {
      console.log(`${[PBI.UPDATE_POWERBI_REPORT]}: error ${error}`)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async [PBI.DELETE_POWERBI_REPORT]({ commit }, selectedReportId) {
    try {
      await Promise.all(
        selectedReportId.map(
          async id => await services.powerBi.deleteData('deleteReport', id),
        ),
      )
    } catch (error) {
      console.log(`${[PBI.DELETE_POWERBI_REPORT]}: error ${error}`)
    }
  },
  [PBI.CANCEL_CHANGES]({ commit }) {
    const previousState = JSON.parse(JSON.stringify(state.preservedDashboard))
    commit(PBI.UPDATE_SELECTED_POWERBI_DASHBOARD, previousState)
    commit(PBI.UPDATE_VALID_DASHBOARD_NAME, true)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
